/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_5WzvirwxV",
    "aws_user_pools_web_client_id": "1k7phes76omcbju7ok0g0s0nrc",
    "oauth": {}
};


export default awsmobile;
